import React from "react";
import { Button } from "@/components/ui/button";

/**
 * Minimized cookie prompt shown when user has not accepted cookies.
 * Renders at bottom-right with short message and Accept only.
 * Full CookieConsentModal is shown when user tries to interact (e.g. send code) without accepting.
 */
const CookieConsentBanner = ({ onAccept }) => {
	return (
		<div
			className="fixed bottom-4 right-4 z-[10050] flex max-w-[320px] items-center gap-3 rounded-xl border border-slate-200 bg-white/95 px-4 py-3 shadow-lg backdrop-blur-sm dark:border-slate-700 dark:bg-slate-900/95 sm:bottom-5 sm:right-5 sm:max-w-[360px] sm:px-5 sm:py-3.5"
			role="status"
			aria-live="polite"
		>
			<p className="flex-1 text-left text-xs text-slate-600 dark:text-slate-300 sm:text-sm">
				We use cookies to keep your experience secure.
			</p>
			<Button
				onClick={onAccept}
				size="sm"
				className="shrink-0 rounded-lg bg-blue-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-blue-500 sm:px-4 sm:py-2 sm:text-sm"
			>
				Accept
			</Button>
		</div>
	);
};

export default CookieConsentBanner;
